import styled from 'styled-components';
import { Dropdown } from 'react-bootstrap';
import { BS_MODAL_BACKDROP_ZINDEX, STATIC_IMAGE_URLS } from 'modules/core/constants';
import { COLORS } from 'modules/core/theme/colors';
import { WindowBreakpoints } from 'modules/core/enums/windowBreakpoints.enum';

export const HeaderWrapper = styled.div<{ needExtraSpace?: boolean; withoutSideBar?: boolean }>`
  /* Clears the collapsed SideBar. Pages rendered without one opt out via withoutSideBar. */
  margin-left: ${({ withoutSideBar }) => (withoutSideBar ? '0' : '42px')};
  position: relative;
  display: flex;
  padding-left: ${({ needExtraSpace }) => (needExtraSpace ? '8px' : '15px')};
  justify-content: space-between;
  background-color: ${COLORS.BLUE_5};
  height: 42px;

  @media (max-width: ${WindowBreakpoints.modalPageView}px) {
    z-index: ${BS_MODAL_BACKDROP_ZINDEX - 1};
    position: sticky;
    top: 0;
  }
`;

export const NavigationWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const UserName = styled.div`
  font-size: 17px;
  color: ${COLORS.WHITE};
  text-transform: capitalize;

  @media (max-width: ${WindowBreakpoints.small}px) {
    display: flex;
    font-size: ${({ theme: { fontSize } }) => fontSize.normal};
    width: 105px;
    overflow: hidden;
  }
`;

export const UserMenu = styled(Dropdown.Menu)`
  padding: 0;
  background-color: ${COLORS.BLUE_5};
  border-radius: 0;
  border: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  right: 0;
  left: auto;
`;

export const DropdownToggle = styled(Dropdown.Toggle)`
  &,
  &:hover,
  &:active,
  &:focus {
    height: 44px;
    display: inline-block;
    padding: 12px 0px 6px 0px;
    cursor: pointer;
    font-size: 15px;
    color: ${COLORS.WHITE} !important;
    background-color: ${COLORS.BLUE_5} !important;
    border: none;
    box-shadow: none !important;

    @media (max-width: ${WindowBreakpoints.small}px) {
      margin-right: 2px;
      padding-left: 0;
    }
  }
`;

export const DropdownToggleWithIcon = styled(DropdownToggle)`
  background: url(${STATIC_IMAGE_URLS.icons.user}) no-repeat center;
  background-size: contain;
  height: 30px !important;

  &::after {
    padding-bottom: 5px;
    margin-left: 50px;

    @media (max-width: ${WindowBreakpoints.small}px) {
      font-size: 14px;
    }
  }
`;

export const DropdownItem = styled(Dropdown.Item)`
  padding: 7px 53px 7px 10px;
  cursor: pointer;

  &,
  &:hover {
    color: ${COLORS.WHITE};
  }

  &:hover {
    background-color: ${COLORS.WHITE_4};
    color: ${COLORS.BLUE_5};
  }
`;
